<template>
	<button
		ref="ctaRef"
		type="button"
		class="btn btn-secondary rounded-none rounded-l-full px-4 hover:z-10 relative"
		:class="customClass"
		:aria-label="isDropdownVisible ? 'Skrýt nákupní seznam' : 'Zobrazit nákupní seznam'"
		:aria-expanded="isDropdownVisible"
		@click="handleClick"
	>
		<NuxtIcon
			name="shopping-list"
			filled
			class="text-[1.25rem]"
		/>
		<ClientOnly>
			<span
				v-if="selectedShoppingListTotalCount !== null"
				class="absolute bottom-[43%] left-[45%] flex h-5 min-w-5 px-1 items-center justify-center rounded-full text-xs font-normal bg-green-600 text-white pointer-events-none"
			>
				{{ selectedShoppingListTotalCount }}
			</span>
		</ClientOnly>
	</button>

	<Teleport to="#header">
		<Transition name="fade">
			<div
				v-if="isDropdownVisible"
				ref="dropdownRef"
				:style="{...floatingStyles}"
			>
				<LazyShoppingListMenuDialog
					v-model:visible="isDropdownVisible"
				/>
			</div>
		</Transition>
	</Teleport>
	<ClientTeleport>
		<LazyUiBackdrop v-model:visible="isDropdownVisible" />
	</ClientTeleport>
</template>

<script setup lang="ts">
	import {useFloating, offset, shift, autoUpdate} from '@floating-ui/vue';
	import {storeToRefs} from 'pinia';
	import {onClickOutside} from '@vueuse/core';
	import {useShoppingListsStore} from '../../stores/shoppingLists';

	interface Props {
		customClass?: string
	}

	defineProps<Props>();

	const shoppingListsStore = useShoppingListsStore();
	const {selectedShoppingListTotalCount} = storeToRefs(shoppingListsStore);

	const cta = useTemplateRef('ctaRef');
	const dropdown = useTemplateRef('dropdownRef');

	const [isDropdownVisible, toggleDropdownVisible] = useToggle();
	const {floatingStyles} = useFloating(cta, dropdown, {
		placement: 'bottom',
		whileElementsMounted: autoUpdate,
		middleware: [offset(0), shift({padding: 20})],
	});

	onClickOutside(dropdown, () => (isDropdownVisible.value = false), {ignore: [cta]});

	function handleClick() {
		toggleDropdownVisible();
		trackHeaderEvent('list_icon_top');
	}

	onMounted(() => {
		shoppingListsStore.fetchShoppingLists();
	});
</script>
